import React, { useState, useEffect } from "react";
import { Typography } from "@mui/material";

const DefectsTable = ({ defectsData }) => {
  const [fiscalYears, setFiscalYears] = useState([]);

  useEffect(() => {
    if (Object.keys(defectsData)?.length > 0) {
      const years = Object.values(defectsData)[0]
        ? Object.keys(Object.values(defectsData)[0])
        : [];
      setFiscalYears(years);
    }
  }, [defectsData]);

  return (
    <div style={{ overflowX: "auto" }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Top 10 Defect Summary
      </Typography>
      {Object?.keys(defectsData)?.length > 0 ? (
        <table
          style={{
            borderCollapse: "collapse",
            width: "100%",
            fontFamily: "Arial, sans-serif",
            fontSize: "16px",
          }}
        >
          <thead style={{ backgroundColor: "#0070C0", color: "white" }}>
            <tr>
              <th
                style={{
                  padding: "12px",
                  border: "1px solid #ddd",
                  fontWeight: "bold",
                }}
              >
                Top Defects
              </th>
              {fiscalYears.map((year) => (
                <th
                  key={year}
                  style={{
                    padding: "12px",
                    border: "1px solid #ddd",
                    fontWeight: "bold",
                  }}
                >
                  {year}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Object.entries(defectsData).map(([defect, values], index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#f9f9f9" : "white",
                }}
              >
                <td
                  style={{
                    textAlign: "left",
                    padding: "12px",
                    border: "1px solid #ddd",
                    fontWeight: 500,
                  }}
                >
                  {defect}
                </td>
                {fiscalYears.map((year, i) => {
                  const value = values[year] ?? 0;
                  let color = "#000"; // default color

                  const isYearFormat = /^\d{4}-\d{4}$/.test(year); // check if it's a fiscal year format

                  if (isYearFormat && i > 0) {
                    const prevYear = fiscalYears[i - 1];
                    const prevValue = values[prevYear] ?? 0;
                    if (!isNaN(prevValue)) {
                      if (value > prevValue) color = "red";
                      else if (value < prevValue) color = "#32b361";
                    }
                  } else if (year === "POST_CUT_IN" && "PRE_CUT_IN" in values) {
                    const prev = values["PRE_CUT_IN"];
                    if (value > prev) color = "red";
                    else if (value < prev) color = "#32b361";
                  }

                  return (
                    <td
                      key={year}
                      style={{
                        padding: "12px",
                        border: "1px solid #ddd",
                        color,
                        fontWeight: 500,
                      }}
                    >
                      {value}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <Typography
          variant="h5"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: 5,
            mb: 5,
          }}
        >
          No Data
        </Typography>
      )}
    </div>
  );
};

export default DefectsTable;
